import "./Dialog.css";

import {useEffect, useRef} from "react";

export default function Dialog({
  title,
  description,
  confirmTitle,
  destructiveTitle,
  confirmHandler,
  destructiveHandler,
  className = "",
}) {
  const dialogRef = useRef(null);

  useEffect(() => {
    dialogRef.current?.showModal();
  }, []);

  return (
    <dialog ref={dialogRef} className={`rounded-lg ${className}`}>
      <div className="bg-white flex flex-col p-4 gap-8">
        <div className="text-center">
          <div className="flex flex-col gap-3">
            {title && <h3 className="text-base font-bold text-lg text-gray-900">{title}</h3>}
            {description && (
              <div>
                <p className="text-base text-gray-500">{description}</p>
              </div>
            )}
          </div>
        </div>
        <div className="flex col-flex gap-4">
          {destructiveTitle && (
            <button type="button" onClick={destructiveHandler} className="inline-flex w-full justify-center rounded-md bg-red-600 p-3 text-sm font-bold text-white shadow-xs hover:bg-red-500">
              {destructiveTitle}
            </button>
          )}
          {confirmTitle && (
            <button type="button" onClick={confirmHandler} className="inline-flex w-full justify-center rounded-md bg-primary-500 p-3 text-sm font-bold text-white shadow-xs hover:bg-primary-700">
              {confirmTitle}
            </button>
          )}
        </div>
      </div>
    </dialog>
  );
}
